<template>
  <ul class="orderInfo">
    <li>
      <div class="th">结算时间</div>
      <div class="td">{{ orderDeatilsData.payTime&&orderDeatilsData.orderStatus==2? orderDeatilsData.payTime :'--' }}</div>
    </li>
    <li>
      <div class="th">消费总额</div>
      <div class="td">{{ '￥'+orderDeatilsData.initAmount || '--' }}</div>
    </li>
    <li>
      <div class="th">优惠金额</div>
      <div class="td">
        {{ '-￥'+totalDiscountMoney() || '--' }}
        <el-tooltip v-if="totalDiscountMoney()" effect="light" placement="right">
          <div slot="content">
            <h5 v-for="(v,n) in orderDeatilsData.discountDetailList" :key="n">{{ v.discountType }}：￥{{ v.discountPrice }}</h5>
          </div>
          <i class="iconfont" style="font-size: 14px;color:#d3d3d3">&#xe71a;</i>
        </el-tooltip>
      </div>
    </li>
    <li>
      <div class="th">划扣金额</div>
      <div v-if="!orderDeatilsData.bookOrderMsgDTO||orderDeatilsData.bookOrderMsgDTO&&orderDeatilsData.bookOrderMsgDTO.deductType==1" class="td">
        {{ '-￥'+(orderDeatilsData.deductAmount*1+orderDeatilsData.giftDeduct*1+orderDeatilsData.electronicTicketDeduct*1).toFixed(2) || '--' }}
        <el-tooltip v-if="(orderDeatilsData.deductAmount*1+orderDeatilsData.giftDeduct*1+orderDeatilsData.electronicTicketDeduct*1).toFixed(2)!=0" effect="light" placement="right">
          <div slot="content">
            <h5 v-if="orderDeatilsData.deductAmount*1 > 0">套餐划扣：-￥{{ orderDeatilsData.deductAmount ? (orderDeatilsData.deductAmount*1).toFixed(2) : '0.00' }}</h5>
            <h5 v-if="orderDeatilsData.giftDeduct*1 > 0">赠送划扣：-￥{{ orderDeatilsData.giftDeduct ? (orderDeatilsData.giftDeduct*1).toFixed(2) : '0.00' }}</h5>
            <h5 v-if="orderDeatilsData.electronicTicketDeduct*1 > 0">电子票划扣：-￥{{ orderDeatilsData.electronicTicketDeduct ? (orderDeatilsData.electronicTicketDeduct*1).toFixed(2) : '0.00' }}</h5>
          </div>
          <i class="iconfont" style="font-size: 14px;color:#d3d3d3">&#xe71a;</i>
        </el-tooltip>
      </div>

      <div v-else class="td"> -- </div>
    </li>
    <li>
      <div class="th">应收金额</div>
      <!-- <div class="td">{{ orderDeatilsData.shouldAmount != null ? ('￥'+(orderDeatilsData.shouldAmount*1).toFixed(2)) : '--' }}</div> -->
      <div class="td">{{ orderDeatilsData.amount != null ? ('￥'+(orderDeatilsData.amount*1).toFixed(2)) : '--' }}</div>
    </li>

    <li>
      <div class="th">实收金额</div>
      <div v-if="orderDeatilsData.bookOrderMsgDTO &&orderDeatilsData.bookOrderMsgDTO.deductType ==1" class="td">
        {{ orderDeatilsData.orderStatus== 2 ?('￥'+orderDeatilsData.resultAmount) : '--' }}
      </div>
      <div v-else-if="orderDeatilsData.bookOrderMsgDTO &&orderDeatilsData.bookOrderMsgDTO.bookPrice>0 &&orderDeatilsData.bookOrderMsgDTO.buySource == 1&&orderDeatilsData.orderStatus == 1" class="td">
        {{ ('￥'+(orderDeatilsData.bookOrderMsgDTO.bookPrice*1).toFixed(2)) }}(预收定金)
      </div>
      <div v-else-if="orderDeatilsData.resultAmount >0" class="td">
        {{ orderDeatilsData.resultAmount != null ? ('￥'+(orderDeatilsData.resultAmount*1).toFixed(2)) : '--' }}
      </div>
      <div v-else class="td">--</div>
    </li>
    <!-- <li>
      <div class="th">结算方式</div>
      <div class="td">{{ settlementCode&&orderDeatilsData.orderStatus==2 ?settlementCode:'--' }}</div>
    </li> -->
    <li v-if="orderDeatilsData.orderType == 7&&orderDeatilsData.orderStatus ==1">
      <div class="th">结算方式</div>
      <div class="td">--</div>
    </li>
    <li v-if="orderDeatilsData.initAmount >0 &&orderDeatilsData.orderType != 6">
      <div class="th">结算方式</div>
      <div class="td">{{ orderDeatilsData.orderStatus ==1?'--':settlementCode() }}</div>
    </li>
    <li>
      <div class="th">结算人员</div>
      <div class="td">{{ orderDeatilsData.orderStatus ==2&&orderDeatilsData.billingStaff ?orderDeatilsData.billingStaff:'--' }}</div>
    </li>
    <li v-show="orderDeatilsData.partPayType != 1&&orderDeatilsData.payTypeName != '赊账'" class="liALL">
      <div class="th thAll">支付方式</div>
      <div v-if="orderDeatilsData.payTypeList!=null&&orderDeatilsData.payTypeList.length>0" class="td">
        <span v-for="(v,n) in orderDeatilsData.payTypeList" :key="n">
          {{ getPayType(v,n,orderDeatilsData.payTypeList) }}
        </span>
      </div>
      <div v-if="orderDeatilsData.payTypeList==null||orderDeatilsData.payTypeList.length==0" class="td">
        {{ orderDeatilsData.payTypeName?orderDeatilsData.payTypeName+'(￥'+orderDeatilsData.initAmount+')':'--' }}
      </div>
    </li>
    <li v-if="orderDeatilsData.partPayType == 1&&orderDeatilsData.payTypeName != '赊账'" class="liALL">
      <div class="th thAll">剩余款项</div>
      <div class="td">{{ orderDeatilsData.balance ? ('￥'+(orderDeatilsData.balance*1).toFixed(2)) : '--' }}</div>
    </li>
    <!--还款-->
    <li v-if="orderDeatilsData.payTypeName == '赊账'">
      <div class="th">还款状态</div>
      <div class="td" :class="orderDeatilsData.onAccountNoRefundAmount!=0?'resultInfo-hse':orderDeatilsData.refundStatus===0||orderDeatilsData.onAccountNoRefundAmount==0?' resultInfo-lse':'--'">{{ orderDeatilsData.onAccountNoRefundAmount!=0?'未还清':orderDeatilsData.refundStatus===0||orderDeatilsData.onAccountNoRefundAmount==0?'已还清':'--' }}</div>
    </li>
    <li v-if="orderDeatilsData.payTypeName == '赊账'">
      <div class="th">还款日期</div>
      <div class="td">{{ orderDeatilsData.repayTime||'--' }}</div>
    </li>
    <li v-if="orderDeatilsData.payTypeName == '赊账'" class="liTow">
      <div class="th thTow">还款方式</div>
      <div v-if="orderDeatilsData.payTypeList" class="td">
        <span v-for="(v,n) in orderDeatilsData.payTypeList" :key="n">
          {{ v.payTypeName||'--' }}
        </span>
        <el-tooltip v-if="orderDeatilsData.payTypeList" effect="light" placement="right">
          <div slot="content">
            <h5 v-for="(v,n) in orderDeatilsData.payTypeList" :key="n">
              {{ v.payTypeName||'--' }}
              <!-- {{ v.payType == 1 ? '现金' : v.payType == 2 ? '银行卡' : v.payType == 3 ? '会员卡' : v.payType == 4 ? '扫码' : v.payType == 5 ? '赊账' : v.payType == 6 ? '魔盒' : v.payType == 7 ? '个人微信' : v.payType == 8 ? '个人支付宝' : v.payType == 9 ? '微信（官方）' : v.payType == 10 ? '支付宝（官方）' : v.payType == 11 ? '微信（通联）' : v.payType == 12 ? '支付宝（通联）' : v.payType == 13 ? '微信（翼支付）' : v.payType == 14 ? '支付宝（翼支付）' : v.payType == 15 ? '微信（合利宝）' : v.payType == 16 ? '支付宝（合利宝）' : '其他' }} -->
            </h5>
          </div>
          <i v-if="orderDeatilsData.payTypeList[0].payTypeName" class="iconfont" style="font-size: 14px;">&#xe71a;</i>
        </el-tooltip>
      </div>
      <div v-else class="td"> --</div>
    </li>
  </ul>
</template>

<script>

export default {
  props: {
    orderDeatilsData: {
      type: Object,
      default: () => { }
    },
    // settlementCode: {
    //   type: String,
    //   default: String
    // }
  },
  data() {
    return {
      tooltipStatus: false, // 文字过长的显示和隐藏
    };
  },
  activated() {
  },
  methods: {
    settlementCode() {
      let countTotal = 0;
      let deductCountTotal = 0;
      let countStatus;
      this.orderDeatilsData.itemList.forEach((a) => {
        countTotal += (a.count ? (a.count * 1) : 0);
        deductCountTotal += (a.deductCount ? (a.deductCount * 1) : 0);
      });
      if (countTotal == deductCountTotal) {
        countStatus = 1;
      } else {
        countStatus = 2;
      }
      return this.orderDeatilsData.partPayType == 1 ? '部分支付'
        : this.orderDeatilsData.payTypeName == '赊账' ? '赊账'
          : this.orderDeatilsData.resultAmount == 0 ? (countStatus == 1 || this.orderDeatilsData.orderType == 4) ? '划扣' : (this.orderDeatilsData.deductAmount || this.orderDeatilsData.discountAmount || this.orderDeatilsData.fenbiMoney || this.orderDeatilsData.integralMoney || this.orderDeatilsData.couponMoney) ? '优惠全额抵扣' : '入账' : '入账';
    },
    getPayType(v, n, data) {
      const a = data.length === (n + 1) === true ? '' : ',';
      return v.payType == 1 ? `现金（￥${v.money}）${a}` : v.payType == 2 ? `银行卡（￥${v.money}）${a}` : v.payType == 3 ? `会员卡（￥${v.money}）${a}` : v.payType == 4 ? `扫码（￥${v.money}）,` : v.payType == 5 ? `赊账（￥${v.money}）${a}` : v.payType == 6 ? `魔盒（￥${v.money}）${a}` : v.payType == 7 ? `个人微信（￥${v.money}）${a}` : v.payType == 8 ? `个人支付宝（￥${v.money}）${a}` : v.payType == 9 ? `微信（官方）（￥${v.money}）${a}` : v.payType == 10 ? `支付宝（官方）（￥${v.money}）${a}` : v.payType == 11 ? `微信（通联）（￥${v.money}）${a}` : v.payType == 12 ? `支付宝（通联）（￥${v.money}）${a}` : v.payType == 13 ? `微信（翼支付）（￥${v.money}）${a}` : v.payType == 14 ? `支付宝（翼支付）（￥${v.money}）${a}` : v.payType == 15 ? `微信（合利宝）（￥${v.money}）${a}` : v.payType == 16 ? `支付宝（合利宝）（￥${v.money}）${a}` : v.payType == 17 ? `微信（收银宝）（￥${v.money}）${a}` : v.payType == 18 ? `支付宝（收银宝）（￥${v.money}）${a}` : '其他';
    },
    totalDiscountMoney() {
      let total = 0;
      if (this.orderDeatilsData.discountDetailList) {
        this.orderDeatilsData.discountDetailList.forEach((a) => {
          total += a.discountPrice * 1;
        });
      }
      return total;
    }
  }
};
</script>
<style lang="less" scoped>
.resultInfo-lse{
  color: #2AC410FF;
}
.resultInfo-hse{
  color: #FF4949FF;
}
</style>
